import { ProjectSetupTranslationKeys } from 'intl/keys';
import { TranslationKey } from 'intl/types/translationKey';
import { InvolvementType } from 'shared/domain/company/types/model';

const PROJECT_INVOLVEMENT_TYPE_LABEL_KEYS: Record<
  InvolvementType,
  TranslationKey
> = {
  [InvolvementType.GENERAL_CONTRACTOR]:
    ProjectSetupTranslationKeys.involvementTypeGeneralContractor,
  [InvolvementType.INVESTOR]: ProjectSetupTranslationKeys.involvementTypeInvestor,
  [InvolvementType.SUBCONTRACTOR]:
    ProjectSetupTranslationKeys.involvementTypeSubcontractor,
};

export function projectInvolvementTypeLabelKey(
  type: InvolvementType
): TranslationKey {
  return PROJECT_INVOLVEMENT_TYPE_LABEL_KEYS[type];
}
